export function removeEmpty(obj: any): any {
  if(!Object.entries(obj) || obj.length === 0) return {}
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, v]) => v != null && (v || v === 0))
      .map(([k, v]) => [k, v === Object(v) ? removeEmpty(v) : v])
  );
}

export function findRelativeStatus(value: string, object: {label: string, value: string}[]) {

  let res = object[0].value
  object.forEach((item: any) => {
    if(item.value.toLowerCase() === value.toLowerCase()) {
      res = item.value
    }
  })

  return res;
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function numberToCurrency(number: any) {
  number = parseInt(number) * 0.01 || 0
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(number) as string;
}



  